import { reactive, isRef, h } from 'vue'
import { message, Modal } from 'ant-design-vue'
import { stringUrlToVNode } from '../common/string'

export const spinObject = reactive({
  delay: 50,
  indicator: 'vNode',
  size: 'default',
  spinning: false,
  tip: '加载中...',
  wrapperClassName: ''
})

/**
 * 显示 loading 提示框
 * @param {{ title:String, mask:Boolean }} obj
 */
export function showLoading(obj) {
  const { title, mask } = obj || {}
  if (title) {
    spinObject.tip = title
  } else {
    spinObject.tip = '加载中...'
  }
  spinObject.spinning = true
}

/**
 * 隐藏 loading 提示框
 */
export function hideLoading() {
  spinObject.spinning = false
}

/**
 * 显示消息提示框
 * @param {{ title: String, icon: 'success'|'error'|'info'|'warning'|'warn'|'loading'|'none', image: String, mask: Boolean, duration: Number|'//单位秒。设为 0 时不自动关闭', close: Function }} obj
 */
export function showToast({ title, icon, duration, close }) {
  if (!duration) duration = 3
  message[icon](title, duration, close)
}

/**
 * 隐藏消息提示框
 */
export function hideToast() {
  message.destroy()
}

/**
 * 显示模态弹窗
 * @param {{ title: String, icon: 'success'|'error'|'info'|'warning'|'confirm'|'none', content: String,onOk:Function}} obj
 * @param content ' {0} - {9} '
 * @returns
 */
export async function showModal({ icon, title, content, okText, onOk, cancelText, onCancel, refModal }) {
  // 处理链接
  content = stringUrlToVNode(content)

  return new Promise((resolve, reject) => {
    const modal = Modal[icon]({
      title,
      content,
      okText,
      cancelText,
      onOk: async () => {
        try {
          if (onOk) {
            await onOk()
          }
        } catch (error) {
          reject(error)
        }
        resolve({
          confirm: true
        })
      },
      onCancel: async () => {
        try {
          if (onCancel) {
            await onCancel()
          }
        } catch (error) {
          reject(error)
        }
        resolve({
          cancel: true
        })
      }
    })

    if (isRef(refModal)) {
      refModal.value = modal
    }
  })
}
